import React, { ReactNode } from "react";

import cn from "classnames";

import styles from "./InfoBlockWithImage.module.scss";

interface Props {
  action?: ReactNode;
  className?: string;
  image?: string;
  subTitle?: ReactNode;
  title: ReactNode;
}

const InfoBlockWithImage: React.FC<Props> = ({ action, className, image, subTitle, title }) => (
  <div className={cn(styles.container, className)}>
    <div className={styles.leftPart}>
      <div>
        <p className={styles.itemTitle}>{title}</p>
        <p className={styles.itemSubTitle}>{subTitle}</p>
      </div>
      <div>{action}</div>
    </div>
    {image && (
      <div className={styles.image}>
        <img alt={`${typeof title === "string" ? title : "Block"} Illustration`} src={image} />
      </div>
    )}
  </div>
);

export default InfoBlockWithImage;
